import React, { useContext, useEffect, useState } from "react";
import { IP } from "utils/Host";
import axios from "axios";
  
import style from './PanelDesktop.module.css';

import iconZamowienia from 'assets/iconZamowienia.svg'
import iconTechnolgie from 'assets/iconTechnologie.svg'
import iconUstawienia from 'assets/iconUstawienia.svg'
import iconMagazyn from 'assets/iconMagazyn.svg'
import iconOddanie from 'assets/iconOddanie2.svg'
import iconProcesy from 'assets/iconProcesy.svg'
import iconGant from 'assets/iconGant.svg'
import iconGantMulti from 'assets/iconGantMulti.svg'

import iconKalendarz from 'assets/iconKalendarz.svg'

import OnlineUsersList from "./OnLineUserList/OnlineUsersList";
import NawigacjaBTN from "./Nawigacja/NawigacjaBTN";
import PanelDesktopHeader from "./Header/PanelDesktopHeader";
import PanelDesktopFooter from "./Footer/PanelDesktopFooter";
import { useSocket } from "context/SocketContext";
import Kalkulator from "./Kalkulator/Kalkulator";
import { UIContext } from "context/UIContext";
import Card from "./Nawigacja/Card";
import { 
  
  TrendingUp, 
  Users, 
  CalculatorIcon,
  Layers,
  BarChart3,
  ChartGantt
} from 'lucide-react';
import { ModalInsertContext } from "context/ModalInsertContext";
import PaperStage from "components/PaperStage/PaperStage";
import ClientStage from "components/Klienci/ClientStage";


export default function PanelDesktop2 ({isOnline,navigate,logout})  {
  const [loading, setLoading] = useState(true);
 const {  callPodgladRalizacji,  lokalizacja} = useSocket()
   const uiContext = useContext(UIContext);
     const modalContext = useContext(ModalInsertContext);
   
     const setShowPaperStage = modalContext.setShowPaperStage;


   const [quickActions, setQuickActions] = useState([
      { 
        id: 1, 
        label: 'Przeloty', 
        desc: 'Zestawienie wg spedycji', 
        icon: <BarChart3 size={32} />, 
        glow: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(6, 123, 212, 0.9))' ,
        handle: ()=> {
          navigate("/Statystyki")


        },
      },
      { 
        id: 2, 
        label: 'Baza papierów', 
        desc: 'Zarządzaj papierami', 
        icon: <Layers size={32} />, 
        glow: 'linear-gradient(135deg, rgba(168, 85, 247, 0.2), rgba(236, 72, 153, 0.9))' ,
        handle: ()=> setShowPaperStage(true),
      },
      { 
        id: 3, 
        label: 'Klienci', 
        desc: 'Zarządzaj klientami', 
        icon: <Users size={32} />, 
        glow: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2), rgba(20, 184, 166, 0.9))' ,
        handle: ()=> modalContext.showAddClientStage(true),
      },
            { 
        id: 4, 
        label: 'Karta pracownika', 
        desc: 'Przeloty', 
        // icon: <TrendingUp size={32} />, 
        icon: <TrendingUp size={32} />, 
        glow: 'linear-gradient(135deg, rgba(249, 26, 22, 0.2), rgba(234, 42, 8, 0.9))' ,
        handle: ()=> {
          navigate("/Zestawienia")
          // uiContext.setShowKalkulatorGrzbietu(prev => !prev)
      // toggleActionVisibility2()
        } ,
    
      },
      { 
        id: 5, 
        label: 'Kalkulator do grzbietów', 
        desc: 'Policz grubość grzbietu oraz wagę', 
        // icon: <TrendingUp size={32} />, 
        icon: <CalculatorIcon size={32} />, 
        glow: 'linear-gradient(135deg, rgba(249, 115, 22, 0.2), rgba(234, 179, 8, 0.9))' ,
        handle: ()=> {
          uiContext.setShowKalkulatorGrzbietu(prev => !prev)
      // toggleActionVisibility2()
        } ,
        
    
      },
      { 
        id: 6, 
        label: 'Symulator', 
        desc: 'Symulacja rozmieszczenia prac', 
        // icon: <TrendingUp size={32} />, 
        icon: <ChartGantt size={32} />, 
        glow: 'linear-gradient(135deg, rgba(109, 40, 217, 0.2), rgba(139, 92, 246, 0.9))' ,
        handle: ()=> {
          navigate("/kalendarz26multi")
      // toggleActionVisibility2()
        } ,
        
    
      }

    ]);


const toggleActionVisibility = (id) => {
  setQuickActions(prevActions => 
    prevActions.map(action => 
      action.id === id ? { ...action, show: false } : action
    )
  );
};

const toggleActionVisibility2 = (id) => {
  setQuickActions(quickActions.map(action => { return {...action, show: false} }))
  
    
  
};

  async function checkToken() {
    axios
      .get(IP + "/islogged/" + sessionStorage.getItem("token"))
      .then((res) => {
        if (res.data.Status === "Success") {

// callPodgladRalizacji(todayMinusDniGodziny(1)) // callPodgladRalizacji("2025-10-10 18:00")

        } else {
          navigate("/Login");
        }
      });
  }




  useEffect(() => {
    checkToken();
    lokalizacja.current = "Panel";

    return () => {
      lokalizacja.current = null;
    };
  }, []);

    return(
    
          <div  className={style.main} >
          <PanelDesktopHeader isOnline={isOnline} navigate={navigate} logout={logout}/>
              <Container>
                    <Left>
                      <NawigacjaBTN handler={() => navigate("/Zamowienia")} icon={iconZamowienia} nazwa={"ZAMÓWIENIA"} locked={false}/>
                      <NawigacjaBTN handler={() => navigate("/faktury")} icon={iconTechnolgie} nazwa={"FAKTURY"} locked={false}/>
                      <NawigacjaBTN handler={() => navigate("/ProcesyView")} icon={iconProcesy} nazwa={"PROCESY"} locked={false}/>
                      <NawigacjaBTN handler={() => navigate("/OprawaView")} icon={iconMagazyn} nazwa={"OPRAWA"} locked={false}/>
                      <NawigacjaBTN handler={() => navigate("/Oddania")} icon={iconOddanie} nazwa={"SPEDYCJA"} locked={false}/>
                      <NawigacjaBTN handler={() => navigate("/kalendarz26")} icon={iconGant} nazwa={"PLAN"} locked={false}/>
                      {/* <NawigacjaBTN handler={() => navigate("/kalendarz26multi")} icon={iconGantMulti} nazwa={"SYMULATOR"} locked={false}/> */}
                      {/* <NawigacjaBTN handler={() => navigate("/ustawienia")} icon={iconUstawienia} nazwa={"WZki"} locked={false}/> */}

                      {/* <NawigacjaBTN handler={() => navigate("/Statystyki")} icon={iconWykres} nazwa={"PRODUKCJA"} locked={false}/> */}
                      {/* <NawigacjaBTN handler={() =>uiContext.setShowKalkulatorGrzbietu(!uiContext.showKalkulatorGrzbietu)} icon={iconKalkulator} nazwa={"GRZBIET"} locked={false} nowe={true}/> */}
                    </Left>

                    <Center>
                      <PaperStage parent={"ustawienia"}/>
                                        <ClientStage parent={"ustawienia"}/>
                      <OnlineUsersList />
                        {uiContext.showKalkulatorGrzbietu && <Kalkulator />}
                         {/* <PodgladRealizacji loading={loading}/> */}
                         {/* <DevilUserIcon/> */}

                    </Center>
                    <Right>
                       
                        {/* <Card/> */}
                                    {quickActions.map((action) => (
                                          <Card action={action}/>
                                    ))}
                        
                        
                    </Right>
              </Container>
          <PanelDesktopFooter isOnline={isOnline} navigate={navigate} logout={logout}/>
          </div>
   

           );


};

function Container({ children }) {
  return <div className={style.container}>{children}</div>;
}

function Left({ children }) {
  return <div className={style.left}>{children}</div>;
}

function Center({ children }) {
  return <div className={style.center}>{children}</div>;
}

function Right({ children }) {
  return <div className={style.right}>{children}</div>;
}
